"use strict";

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var _classCallCheck = require("E:\\Projects\\shl\\shl-frontend\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/classCallCheck");
Object.defineProperty(exports, "__esModule", {
  value: true
});
var Log = function Log(sequenceNumber, message, timestampMs, logLevel) {
  _classCallCheck(this, Log);
  this.sequenceNumber = sequenceNumber;
  this.message = message;
  this.timestampMs = timestampMs;
  this.logLevel = logLevel;
};
exports.default = Log;